<script setup lang="ts">
import { mobileOverlayStore } from '@/stores/mobileOverlay';
import { useSidebarStore } from "@/stores/sidebar";
useSidebarStore();
</script>

<template>
    <div v-if="mobileOverlayStore.showOverlay" id="mobile-map-overlay" @click="hideOverlay">
    </div>
</template>


<script lang="ts">
import { defineComponent } from "vue";
import { mapStores } from 'pinia';

export default defineComponent({
    name: "MobileMapOverlayComponent",
    data() {
        return {
            showOverlay: mobileOverlayStore.showOverlay
        };
    },
    computed: {
        ...mapStores(useSidebarStore),
        ...mapStores(mobileOverlayStore),
    },
    methods: {
        toggleOverlay(showOverlay: boolean) {
            this.showOverlay = showOverlay;
        },
        hideOverlay() {
            mobileOverlayStore.showOverlay = false
            this.SidebarStore.toggleMobile()
        }
    },
});
</script>

<style>
#mobile-map-overlay {
    display: flex;
    position: fixed;
    z-index: 1000;
    width: 100%;
    height: 100%;
    background-color: rgba(192, 192, 192, 0.5);
    background-repeat: no-repeat;
    background-position: center;
}
</style>